import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import { OrderEntitiesByNamePipe } from './order-entities-by-name.pipe';
import { FileSizePipe } from './file-size.pipe';
@NgModule({
  declarations:[OrderEntitiesByNamePipe, FileSizePipe],
  imports:[CommonModule],
  exports:[OrderEntitiesByNamePipe, FileSizePipe],
  providers: [OrderEntitiesByNamePipe]
})

export class MainPipe{}